
import './MainContent.css';
import Experience from './Experience';
import Projects from './Projects';
import Education from './Education';
import Skills from './Skills';
const MainContent = () => {
	return (
		<>
			<Experience />
			<Skills />
			<Projects />
			<Education />
		</>
	)
}


export default MainContent;